import React, { Component, useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';
import { DivLoginAnimation } from 'vivace-fluent-motion';
import { Login } from '@componentes/login';
import { injectIntl } from 'react-intl';
import { localeOptions, versionSystem } from '@constants/defaultValues';
import { useSelector, useDispatch } from 'react-redux';
import * as commonActions from '@common/common.action';
import { verificaToken } from '../../acessos.token';
import * as usuarioActions from '@common/usuario/usuario.action';
import { setCurrentLanguage } from '../../helpers';
import {
	LOCAL_STORAGE_USUARIO,
	LOCAL_STORAGE_TOKEN,
	setUrlEditor,
	setFontePadrao
} from '../../localStorage.util';
import LoginApi from './login.api';
import ConfiguracaoApi from '../configuracao/configuracao.api';
import { useHistory, useParams } from 'react-router-dom';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';

const CryptoJS = require('crypto-js');

function LoginContainer(props) {
	const { messages } = props.intl;
	const [user, setUser] = useState('');
	const [currentAccount, setCurrentAccount] = useState();
	const [confirmUser, setConfirmUser] = useState(false);
	const [showCompanies, setShowCompanies] = useState(false);
	const [accounts, setAccounts] = useState([]);
	const [optionsCompanies, setOptionsCompanies] = useState([]);
	const [selectedCompanies, setSelectedCompanies] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');
	const [tempUser, setTempUser] = useState('');
	const [tempPassword, setTempPassword] = useState('');
	const [resetarSenha, setResetarSenha] = useState(false);
	const [showModalConfirmar, setShowModalConfirmar] = useState(false);
	const [modalConfirmarTitulo] = useState(messages['"dashboards.examDetail.headsUp"']);
	const [modalConfirmarMensagem, setModalConfirmarMensagem] = useState('');
	const [modalConfirmarType] = useState('ok');
	const locale = useSelector((state) => state.commonReducer.lang);

	const dispatch = useDispatch();
	const history = useHistory();
	const _params = useParams();
	const _accounts = JSON.parse(localStorage.getItem('accounts'));

	useEffect(() => {
		let params = _params.msn;
		if (params) {
			checkMensagem(params);
		} else {
			const login = verificaToken();
			if (login) {
				history.push('/');
			}
		}
	}, []);

	useEffect(() => {
		if (
			_accounts &&
			_accounts[0] &&
			JSON.stringify(_accounts) !== JSON.stringify(accounts) &&
			_accounts.length > 0
		) {
			setAccounts(_accounts);
			setCurrentAccount(_accounts[0]);
			setConfirmUser(true);
			setErrorMessage('');
			verifyLoginCAS(_accounts[0].username);
		} else {
			setSelectedCompanies(null);
			setOptionsCompanies([]);
			setShowCompanies(false);
			setUser('');
		}
	}, [accounts]);


	const closeModal = () => {
		setModalConfirmarMensagem('');
		setShowModalConfirmar(false)
		props.history.push('/login');
	};

	const checkMensagem = (params) => {
		const base64Matcher = new RegExp(
			'^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$'
		);

		if (base64Matcher.test(params)) {
			const mensagem = atob(params);
			setModalConfirmarMensagem(mensagem);
			setShowModalConfirmar(true);
		}
	};

	function verifyLoginCAS(user) {
		ConfiguracaoApi.getConfiguracaoLogin()
			.then((res) => {
				setShowCompanies(res.casLogin);
				getOptionsCompanies(user);
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function getOptionsCompanies(_user) {
		LoginApi.listarEmpresas(_user)
			.then((res) => {
				setOptionsCompanies(res.data);
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function changeAccouts(e) {
		if(e && e.length ===0){
			setSelectedCompanies(null);
			setUser('');
			setConfirmUser(false);
			localStorage.removeItem('accounts');
		}else{
			localStorage.setItem('accounts', JSON.stringify(e));
		}
		setAccounts(e);
	}

	function checkUser(username) {
		setUser(username);
		LoginApi.verificarusuario({ login: username })
			.then((res) => {
				const { id, nome, nomeUsuario } = res.data;
				const user_id = id == 0 ? nome :id;
				const payload = { name: nome, id:user_id, username: nomeUsuario };

				setCurrentAccount(payload);
				const _accounts = [...accounts];
				if (_accounts.findIndex((x) => (x.id === id) < 0) || (id == 0 && x.name === user_id < 0)) {
					_accounts.push(payload);
					localStorage.setItem('accounts', JSON.stringify(_accounts));
				}

				setConfirmUser(true);
				setAccounts(_accounts);
				setErrorMessage('');
				verifyLoginCAS(username);
				// toast.success(message);
			})
			.catch((err) => {
				if (err && err.response && err.response.data && err.response.name) {
					setErrorMessage(err.response.data.name);
				}else if(err && err.response && err.response.data && err.response.data.length > 0){
					setErrorMessage(err.response.data[0]);
				}else{
					setErrorMessage('Houve um erro ao valição de usuário');
					console.log(err);
				}
				setConfirmUser(false);
			});
	}

	function checkEmail(email) {
		if (email == 'thiago.braga@mv.com.br') {
			alert('Enviou email');
			setErrorMessage('');
		} else {
			setErrorMessage('Email inválido');
		}
	}


	function preencherDadosEditorLocalStorage(){
		ConfiguracaoApi.getConfiguracaoEditor().then((res) => {
			setUrlEditor(res.urlEditor);
			setFontePadrao(res.fontePadrao);
			});
	}

	function sendResetarSenha(e){
		const payload = {
			usuarioId: tempUser,
			SenhaAtual: tempPassword,
			senha:e
		}
		LoginApi.trocarSenha(payload).then((res) => {
			setResetarSenha(false);
		}).catch((err)=>{
			setErrorMessage(err.data);
			setResetarSenha(true);
		});
	}

	function checkPassword(password) {
		const payload = {
			login: currentAccount.username,
			senha: password,
			empresa: selectedCompanies ? selectedCompanies.id.toString() : '',
		};

		setTempPassword(password);

		if (showCompanies && !selectedCompanies) {
			setErrorMessage(messages['general.login.select.company']);
		}

		dispatch(commonActions.showFadeCarregando(true));

		LoginApi.logar(payload).then((user) => {
			if(user.data.alteraSenhaLogin){
				setTempUser(user.data.usuarioId);
				return setResetarSenha(true);
			}
			localStorage.setItem(
				LOCAL_STORAGE_TOKEN,
				`${user.data.tokenType} ${user.data.accessToken}`
			);

			preencherDadosEditorLocalStorage();

			LoginApi.obterRestricoesAcesso(user.data.usuarioId)
				.then((acessos) => {
					let payload = {
						role: acessos.data,
						usuario: user.data.nomeCompleto,
						usuarioId: user.data.usuarioId,
						medicoId: user.data.medicoId,
						medico: user.data.nomeMedico,
						isResidente: user.data.isResidente,
					};

					dispatch(usuarioActions.atualizarUsuario(payload));

					if (acessos.data) {
						const decoded = jwt_decode(user.data.accessToken);
						dispatch(usuarioActions.permissaoUsuario(acessos.data));
						const encrypted = CryptoJS.AES.encrypt(
							JSON.stringify(acessos.data),
							decoded.jti
						).toString();

						const hmac = CryptoJS.HmacSHA256(
							encrypted,
							CryptoJS.SHA256(decoded.jti)
						).toString();
						const transitmessage = hmac + encrypted;
						payload.role = transitmessage;
					}

					localStorage.setItem(
						LOCAL_STORAGE_USUARIO,
						JSON.stringify(payload)
					);

					dispatch(commonActions.showFadeCarregando(false));
					dispatch(commonActions.splash(true));

					setErrorMessage('');

					history.push('/');
				})
				.catch((err) => {
					dispatch(commonActions.showFadeCarregando(false));
					if(err && err.message){
						setErrorMessage(err.message);
					}
				});
			})
			.catch((error) => {
				if(error && error.data){
					setErrorMessage(error.data);
				}
				dispatch(commonActions.showFadeCarregando(false));
			});

		// console.log(payload);
	}

	function changeAccount(e) {
		setCurrentAccount(e);
		e && e.username && verifyLoginCAS(e.username);
		setSelectedCompanies(null);
		if (!e) {
			setConfirmUser(false);
		} else {
			setConfirmUser(true);
		}
	}

	function changeLang(e) {
		setCurrentLanguage(e);
		dispatch(commonActions.atualizaIdioma(e));
	}

	return (
		<React.Fragment>
			{user && user.usuario && <DivLoginAnimation usuario={user.usuario} />}
			<div className="App">
				<ModalConfirmar
					toggleModalConfirmar={() =>
					 setShowModalConfirmar(!showModalConfirmar)}
					type={modalConfirmarType}
					showModalConfirmar={showModalConfirmar}
					titulo={modalConfirmarTitulo}
					mensagem={modalConfirmarMensagem}
					confirmar={() => closeModal()}
				/>
				<Login
					errorMessage={errorMessage}
					currentAccount={currentAccount}
					confirmUser={confirmUser}
					title={messages['general.title']}
					forgotpassword={messages['general.forgotPassword']}
					goback={messages['general.login.back']}
					currentLang={
						locale
							? localeOptions.find(
								(x) => x.id.toLowerCase() === locale.toLowerCase()
							).name
							: ''
					}
					lowercasePasswordLabel={messages['general.login.lowercasePasswordLabel']}
					uppercasePasswordLabel={messages['general.login.uppercasePasswordLabel']}
					numberPasswordLabel={messages['general.login.numberPasswordLabel']}
					caracterPasswordLabel={messages['general.login.caracterPasswordLabel']}
					lenghtEightPasswordLabel={messages['general.login.lenghtEightPasswordLabel']}
					placeholdUser={messages['general.user']}
					placeholdPassword={messages['general.password']}
					placeholdPasswordConfirm={messages['general.login.placeholdPasswordConfirm']}
					placeholdPasswordMustBeEqual={messages['general.login.passwordMustBeEqual']}
					placeholdEmail={messages['general.login.email']}
					wellcome={messages['general.login.wellcome']}
					help={messages['general.help']}
					about={messages['general.about']}
					newAccount={messages['general.login.newaccount']}
					helpRote="/"
					aboutRote="/"
					hideForgotPassword
					inputEnter={{ value: messages['general.login.next'] }}
					text={messages['general.login.text']}
					recoveryText={messages['general.login.mail.recovery']}
					langs={localeOptions.map((x) => {
						x.value = x.id;
						x.label = x.name;
						return x;
					})}
					accounts={accounts}
					placeholdCompanies={messages['general.login.select.company']}
					optionsCompanies={optionsCompanies}
					showCompanies={showCompanies}
					selectedCompanies={selectedCompanies}
					setShowCompanies={setShowCompanies}
					keyCompanies="nome"
					onCompanies={(e) => setSelectedCompanies(e)}
					onAccount={(e) => changeAccount(e)}
					onAccounts={(e) => changeAccouts(e)}
					onGetUser={(e) => checkUser(e)}
					onGetPassword={(e) => checkPassword(e)}
					onGetRecovery={(e) => checkEmail(e)}
					onLang={(e) => changeLang(e)}
					onTheme={(e) => changeTheme(e)}
					resetPassword={resetarSenha}
					onResetSenha={(e)=>{ sendResetarSenha(e)}}
					setResetarSenha={setResetarSenha}

				/>
			</div>

			<div className="login-footer">
				<div data-bn-type="text" className="copyright">
					{messages['general.copyright']} - {versionSystem}
				</div>
			</div>
		</React.Fragment>
	);
}

export default injectIntl(LoginContainer);



// WEBPACK FOOTER //
// ./src/pages/login/login.container.js